import { JBaseApi } from '../base';
import { ApiWrapper, CustomActionUpdate } from '../../types';
import { OF } from '../../util';
import { ActionVerb } from '../../types/global';

export class JGlobalApi extends JBaseApi {
    public countAction(verb: ActionVerb, uri: string): Promise<ApiWrapper<number>> {
        return this.network.post({
            o: 'activityLog',
            f: 'log',
            count: true,
            verb,
            uri,
        } as OF);
    }

    public updateAction<T>(
        params: { type: string; targetId: number; targetType: string; value: T },
        options?: {
            signal?: AbortSignal;
        },
    ): Promise<ApiWrapper<CustomActionUpdate>> {
        return this.network.post(
            {
                o: 'customAction',
                f: 'update',
                ...params,
            } as OF,
            options?.signal,
        );
    }

    public useWebVersion() {
        return this.network.post({
            o: 'global',
            f: 'useWebVersion',
        } as OF);
    }
}
